export const VACATION_TYPES = {
  VB_EXTRA: 'VB_EXTRA',
  VB_USED: 'VB_USED',
};
